module.exports = __webpack_public_path__ + "static/media/22829741_1629546967120488_10400990566682523_o.28054ffc.jpg";